import React from "react";
import {
  Button,
  Col,
  Container,
  FormControl,
  FormLabel,
  Row,
} from "react-bootstrap";
import {
  LogisticOrderReceiptSearchCriteria,
  PageListBean,
  RestLogisticOrderReceiptListRequest,
} from "../ds/ds.js";
import { LookupHandler, LookupResultDetails } from "../ds/lookup_ds.js";
import { Eraser, TickIcon } from "../gui_components/Icons.js";
import { InputTextbox, ShowError } from "../gui_components/UIComponents.js";
import {
  isEmpty,
  isEmptyArray,
  isEmptyString,
} from "../gui_components/Util.js";
import { ModuleUtils } from "../modules/ModuleUtils.js";
import { LogisticOrderReceiptService } from "../services/LogisticOrderReceiptService.js";
export class LogisticReceiptLookupHandler extends LookupHandler {
  constructor(companyCode, attribute_name) {
    super();
    this.attribute_name = attribute_name;
    this.lookupTitle = attribute_name + " Lookup";
    this.companyCode = companyCode;
    // this.customerCode = customerCode;
    // this.status = status;
    let resetCriteria = new LogisticOrderReceiptSearchCriteria();
    resetCriteria.companyCode = companyCode;
    this.resetCriteria = resetCriteria;
    let logisticReceiptLookupCriteria =
      new LogisticOrderReceiptSearchCriteria();
    logisticReceiptLookupCriteria.companyCode = this.companyCode;
    // logisticReceiptLookupCriteria.customerCode = this.customerCode;
    // logisticReceiptLookupCriteria.orderStatus = this.status;
    let newCriteria = new LogisticOrderReceiptSearchCriteria();
    newCriteria.companyCode = companyCode;
    this.newCriteria = newCriteria;
    let lookupCriteriaView = LogisticReceiptLookupCriteriaHandler(
      companyCode,
      logisticReceiptLookupCriteria
    );
    let lookupDataCallback = function (
      lookup_dialog,
      page_number,
      searchCriteria,
      filterText
    ) {
      this.fetchDataFromService(
        lookup_dialog,
        page_number,
        searchCriteria,
        filterText
      );
    };
    this.setDetails(
      lookupDataCallback,
      logisticReceiptLookupCriteria,
      lookupCriteriaView
    );
    ModuleUtils.getLogisticOrderReceiptStatusList();
    this.initColumns();
  }
  initColumns() {
    this.addColumnDefinition(this.attribute_name, "code", 0, true); //1
    this.addColumnDefinition(" Order Number", "logisticOrderNumber", 0, false); //1
    this.addColumnDefinition(" Customer", "customerCode", 0, false); //1
    this.addColumnDefinition(" Customer Name", "customerName", 0, false); //1
    this.addColumnDefinition(" Receipt Date", "receiptDate", 0, false); //3
    this.addColumnDefinition(" Container", "containerNumber", 0, false); //1
    this.addColumnDefinition(" BillOfLading", "billOfLading", 0, false); //1
    this.addColumnDefinition(
      "  Reference#",
      "customerReferenceNumber",
      0,
      false
    ); //1
    this.addColumnDefinition(
      "ContainerNumber#",
      "containerNumber",
      0,
      false
    );
    this.addColumnDefinition("Status", "receiptStatus", 0, false); //3
  }
  loadLogisticReceiptList = (lookup_dialog, pageNumber, searchCriteria) => {
    let criteria = new LogisticOrderReceiptSearchCriteria(); //To be fetched from CriteriaHandler
    criteria.companyCode = this.companyCode;
    if (searchCriteria !== undefined && searchCriteria !== null) {
      criteria.logisticOrderReceiptNumberStartsWith =
        searchCriteria.logisticOrderReceiptNumberStartsWith;
      criteria.logisticOrderReceiptNumberContains =
        searchCriteria.logisticOrderReceiptNumberContains;
      criteria.logisticOrderNumber = searchCriteria.logisticOrderNumber;
      criteria.logisticOrderReceiptNumber =
        searchCriteria.logisticOrderReceiptNumber;
      criteria.customerCode = searchCriteria.customerCode;
      criteria.containerNumber = searchCriteria.containerNumber;
      // if (isEmptyString(this.status)) {
      criteria.receiptStatus = searchCriteria.receiptStatus;
      // } else {
      //   criteria.orderStatus = this.status;
      // }
    }
    let pageList = new PageListBean();
    pageList.pageSize = 50; //TODO --> Fetch from Config
    pageList.pageNumber = pageNumber;
    pageList.currentPage = pageNumber;
    let requestInput = new RestLogisticOrderReceiptListRequest();
    requestInput.pageInput = pageList;
    requestInput.criteria = criteria;
    LogisticOrderReceiptService.getLogisticOrderReceiptPageList(
      requestInput,
      (response) => this.loadResponse(response, lookup_dialog),
      this.loadError
    );
  };
  loadResponse = (response, lookup_dialog) => {
    let receiptList = [];
    let totalCount = 0;
    let currentPageNumber = 0;
    let pageSize = 0;
    if (
      !isEmpty(response.data) &&
      !isEmpty(response.data.logisticOrderReceiptPageList) &&
      !isEmptyArray(
        response.data.logisticOrderReceiptPageList.logisticOrderReceipts
      )
    ) {
      receiptList =
        response.data.logisticOrderReceiptPageList.logisticOrderReceipts;
      totalCount = response.data.logisticOrderReceiptPageList.totalCount;
      currentPageNumber =
        response.data.logisticOrderReceiptPageList.currentPage;
      pageSize = response.data.logisticOrderReceiptPageList.pageSize;
      receiptList.map((pl) => {
        pl.receiptStatus = ModuleUtils.getLogisticOrderReceiptStatusCaption(
          pl.receiptStatus
        );
      });
    }
    let lookup_result_details = new LookupResultDetails();
    lookup_result_details.pageData = receiptList;
    let total_count = 0;
    if (this.lookup_data != null) {
      total_count = this.lookup_data.length;
    }
    lookup_result_details.totalRecordsCount = totalCount;
    lookup_result_details.currentPageNumber = currentPageNumber;
    lookup_result_details.pageSize = pageSize;
    lookup_result_details.criteriaDisplayString = ""; //TODO
    lookup_dialog.updateResultCallBack(lookup_result_details);
  };
  loadError = (error) => {
    ShowError("Error : " + error);
  };
  fetchDataFromService(lookup_dialog, pageNumber, searchCriteria, filterText) {
    let search = { ...searchCriteria };
    if (search != null && search != "unDefined") {
      // if (isEmptyString(search.logisticOrderReceiptNumberContains)) {
      if (!isEmptyString(filterText)) {
        search.logisticOrderReceiptNumberContains = filterText;
        this.searchCriteria = new LogisticOrderReceiptSearchCriteria();
      }
    }
    if (lookup_dialog != null) {
      this.loadLogisticReceiptList(lookup_dialog, pageNumber, search);
    }
  }
}
const LogisticReceiptLookupCriteriaHandler = (
  companyCode,
  logisticReceiptLookupCriteria
) => {
  return class extends React.Component {
    constructor(props) {
      super(props);
      this.state = {
        searchCriteria: new LogisticOrderReceiptSearchCriteria(),
      };
      this.criteriaLookupHandler = React.createRef();
      this.focusRef = React.createRef();
    }
    componentDidMount() {
      let searchCriteria = this.state.searchCriteria;
      searchCriteria.companyCode = companyCode;
      this.setState({ searchCriteria: searchCriteria });
      if (this.focusRef.current) this.focusRef.current.focus();
    }
    continueButtonClick = () => {
      this.props.searchCriteriaCallBack(this.state.searchCriteria);
    };
    onChange = (e) => {
      let temp_searchCriteria = this.state.searchCriteria;
      temp_searchCriteria[e.target.name] = e.target.value;
      this.setState({ searchCriteria: temp_searchCriteria });
    };
    clearCriteria = () => {
      let searchCriteria = new LogisticOrderReceiptSearchCriteria();
      searchCriteria.companyCode = companyCode;
      this.setState({ searchCriteria: searchCriteria });
      if (this.focusRef.current) this.focusRef.current.focus();
    };
    onContainerKeyDown = (e) => {
      if (e.ctrlKey && e.keyCode == "191") {
        this.continueButtonClick();
      }
    };
    render() {
      let searchCriteria = this.state.searchCriteria;
      return (
        <div>
          <Container onKeyDown={this.onContainerKeyDown}>
            <Row>
              <Col sm={5}>
                <FormLabel>InBound Receipt Number</FormLabel>
              </Col>
              <Col sm={7}>
                <InputTextbox
                  id="logisticOrderReceiptNumber"
                  name="logisticOrderReceiptNumber"
                  onChange={this.onChange}
                  value={searchCriteria.logisticOrderReceiptNumber}
                />
              </Col>
            </Row>
            <Row>
              <Col sm={5}>
                <FormLabel>InBound Receipt StartsWith</FormLabel>
              </Col>
              <Col sm={7}>
                <InputTextbox
                  id="logisticOrderReceiptNumberStartsWith"
                  name="logisticOrderReceiptNumberStartsWith"
                  onChange={this.onChange}
                  value={searchCriteria.logisticOrderReceiptNumberStartsWith}
                />
              </Col>
            </Row>
            <Row>
              <Col sm={5}>
                <FormLabel>InBound Receipt Contains</FormLabel>
              </Col>
              <Col sm={7}>
                <InputTextbox
                  id="logisticOrderReceiptNumberContains"
                  name="logisticOrderReceiptNumberContains"
                  onChange={this.onChange}
                  value={searchCriteria.logisticOrderReceiptNumberContains}
                />
              </Col>
            </Row>
            <Row>
              <Col sm={5}>
                <FormLabel>Container Number</FormLabel>
              </Col>
              <Col sm={7}>
                <InputTextbox
                  id="containerNumber"
                  name="containerNumber"
                  onChange={this.onChange}
                  value={searchCriteria.containerNumber}
                />
              </Col>
            </Row>
            <Row>
              <Col sm={5}>
                <FormLabel>Status</FormLabel>
              </Col>
              <Col sm={7}>
                <FormControl
                  as="select"
                  custom
                  onChange={this.onChange}
                  name="receiptStatus"
                  value={searchCriteria.receiptStatus}
                >
                  <option value={""}></option>
                  <option value={"A"}>Approved</option>
                  <option value={"U"}>UnApproved</option>
                  {/* <option value={"R"}>Received</option>
                  <option value={"I"}>Partially Received</option>
                  <option value={"H"}>Force Close</option> */}
                  <option value={"X"}>Cancelled</option>
                </FormControl>
              </Col>
            </Row>

            <Row className="popup_criteria_button_align-lookup">
              <Button
                ref={this.focusRef}
                className="header_buttons btn btn-primary btn-sm enterFocus"
                onClick={this.continueButtonClick}
              >
                <TickIcon />
                Continue
              </Button>
              <Button
                className="header_buttons btn btn-primary btn-sm enterFocus"
                onClick={this.clearCriteria}
              >
                <Eraser />
                Clear
              </Button>
            </Row>
          </Container>
        </div>
      );
    }
  };
};
